import * as React from 'react';
import { Box, Button, IconButton, Tooltip, Typography } from "@mui/material";
import { AIAccessTypeEnum, AccessesToModelsDto } from '../../@shared/Models/AccessModels';
import ClearIcon from '@mui/icons-material/Clear';
import { FlexBoxInline, PrimaryBtnSx, SecondaryBtnSx } from '../../@shared/templates';
import { Palette, Sizes } from '../../@shared/palette';
import { UserAvatar } from '../../components/UserAvatar';

export type AccessUserItemType = {
  accesses: AccessesToModelsDto;
  onUpdateAccess: (email: string | undefined, role: AIAccessTypeEnum) => void;
  onRemoveAccess: (email: string) => void;
}

export const AccessUserItem = (props: AccessUserItemType) => {
  const handleChange = (newRole: AIAccessTypeEnum) => {
    if (newRole !== props.accesses.accessTypeId) {
      props.onUpdateAccess(props.accesses.user.email, newRole)
    }
  };

  const validateRole = (role: AIAccessTypeEnum) => {
    return role === props.accesses.accessTypeId;
  }

  const getBtnStyles = (role: AIAccessTypeEnum) => {
    if (!validateRole(role)) {
      return { ...SecondaryBtnSx };
    }

    return {
      ...PrimaryBtnSx,
      "&.Mui-disabled": {
        color: Palette.btnPrimary,
      }
    };
  }

  return <Box sx={{ ...FlexBoxInline, justifyContent: "space-between", marginBottom: "0" }}>
    <Box sx={{ ...FlexBoxInline, gap: "10px" }}>
      <UserAvatar user={props.accesses.user} size={32} />
      <Typography sx={{
        fontSize: Sizes.textPrimary,
        color: Palette.textColorPrimary,
      }}>{props.accesses.user.email}</Typography>
    </Box>
    <Box sx={FlexBoxInline}>
      <Box sx={{ ...FlexBoxInline, gap: 0 }}>
        <Button
          sx={{ ...getBtnStyles(AIAccessTypeEnum.Observer), borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: "1px solid " + Palette.btnPrimary }}
          disabled={validateRole(AIAccessTypeEnum.Observer)}
          onClick={() => handleChange(AIAccessTypeEnum.Observer)}>
          Observer
        </Button>
        <Button
          sx={{ ...getBtnStyles(AIAccessTypeEnum.Admin), borderTopLeftRadius: 0, borderBottomLeftRadius: 0, borderLeft: "none" }}
          disabled={validateRole(AIAccessTypeEnum.Admin)}
          onClick={() => handleChange(AIAccessTypeEnum.Admin)}>
          Admin
        </Button>
      </Box>
      <Tooltip title={"Remove access"} placement="bottom" arrow>
        <IconButton sx={{ ...SecondaryBtnSx, p: "5px", border: "none" }} aria-label="delete" onClick={() => props.onRemoveAccess(props.accesses.id)}>
          <ClearIcon sx={{ fontSize: Sizes.icon }} />
        </IconButton>
      </Tooltip>
    </Box>
  </Box>

}